import { render, staticRenderFns } from "./m-orm-table.vue?vue&type=template&id=4e4c1d28&lang=pug"
import script from "./m-orm-table.vue?vue&type=script&lang=js"
export * from "./m-orm-table.vue?vue&type=script&lang=js"
import style0 from "./m-orm-table.vue?vue&type=style&index=0&id=4e4c1d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports